document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".scroll__up")) {
    
    // Get a reference to the button element
    const scrollToTopButton = document.querySelector(".scroll__up");
    // Set a variable to keep track of the last scroll position
    let lastScrollPosition = 0;

    // Add a scroll event listener to the window
    window.addEventListener('scroll', () => {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset;

      // Check if the user has scrolled up or down
      if (currentScrollPosition < lastScrollPosition) {
        // If the user has scrolled up, show the button
        scrollToTopButton.style.visibility = 'visible';
      } else {
        // If the user has scrolled down, hide the button
        scrollToTopButton.style.visibility = 'hidden';
      }

      if (window.pageYOffset < 20) {
        scrollToTopButton.style.visibility = 'hidden';
      }

      // Update the last scroll position
      lastScrollPosition = currentScrollPosition;
    });

    // Add a click event listener to the button
    scrollToTopButton.addEventListener('click', () => {
      // Scroll the user to the top of the page
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
})